import { useTLang } from 'intl/intl';
import { useSaturationStateText } from 'features/high-demand/shared/hooks';

import type { SaturationStateProp } from 'features/high-demand/shared/models';

export function useSaturationChipLang(props: Props) {
  const { variant } = props;

  const tooltipId = `highDemand.saturationChip.tooltip.${variant}`;

  const { status: legend } = useSaturationStateText({ variant });

  return {
    legend,
    tooltip: useTLang({ id: variant !== 'fastFromOCC' ? tooltipId : '' }),
  };
}

interface Props extends SaturationStateProp {}
